export const apiUrls = {
  basic: {
    merge: '/units/join/{{unitId}}',
    office: '/units/update_type/{{unitId}}',
    buildingPhase: '/objects/update_section/{{sectionId}}?act=submit',
    splitted: '/units/split/{{unitId}}',
  },
  rooms: {
    change: '/section/{{sectionId}}/rooms',
  },
  area: {
    change: '/section/{{sectionId}}/area',
  },
  price: {
    change: '/section/{{sectionId}}/price',
  },
  apt: {
    change: '/section/{{sectionId}}/num/',
  },
  feature: {
    mark: '/units/bind_label/{{unitId}}',
    markCustom: '/units/bind_field/{{unitId}}',
  },
  images: {
    upload: '/images/upload?act=submit',
  },
  review: {
    status: '/api/unit/{{unitId}}/update_status',
  },
  image: {
    remove: '/images/delete?act=submit',
    bind: '/units/bind_image/{{unitId}}',
    bindBulk: '/api/unit/bind_image_bulk',
  },
  production: {
    popup: '/units/single/{{unitId}}',
    getTasks: '/tasks/get/{{type}}/{{for_id}}',
    newTask: '/tasks/create?act=submit',
    removeTask: '/tasks/delete?act=submit',
    solveTask: '/tasks/solve?act=submit',
    updateTask: '/tasks/update?act=submit',
    unitStatus: ' /units/update_status/{{unitId}}',
    addNote: '/activities/create',
    dealParameters: '/deals/detailed/{{dealId}}',
    saveDealParameters: '/deals/update/{{dealId}}?act=submit',
    getActivity: '/units/activity/{{unitId}}',
  },
  leads: {
    updateStatus: '/leads/update_status/{{leadId}}',
    updateContacts: '/leads/update_additional/{{leadId}}?act=submit',
    newContacts: '/leads/create_additional/{{leadId}}?act=submit',
    removeInterested: '/leads/unset_unit?act=submit',
  },
  filter: '/sections/filter/{{sectionId}}',
  saveFilter: '/searches/create?act=submit',
} as const;

export type ApiUrls = typeof apiUrls;
